// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-menu-toggle {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  z-index: 1001;
  position: relative;
}

.hamburger {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 24px;
  height: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.hamburger span {
  width: 100%;
  height: 2px;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger.open span:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.hamburger.open span:nth-child(2) {
  opacity: 0;
}

.hamburger.open span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100vh;
  background: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: none;
  flex-direction: column;
  overflow-y: auto;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.mobile-menu-header h2 {
  margin: 0;
  font-size: 1.25rem;
}

.mobile-menu-close {
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.mobile-menu-links {
  flex: 1 1;
  padding: 1rem 0;
}

.mobile-menu-links a {
  display: block;
  padding: 1rem 1.5rem;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
}

.mobile-menu-links a:hover {
  background: #f8f9fa;
}

.mobile-menu-links a.active {
  background: #e7e9fd;
  color: #667eea;
  font-weight: 600;
  border-left: 3px solid #667eea;
}

.mobile-menu-footer {
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
}

.mobile-user-info {
  padding: 0.75rem 0;
  font-size: 0.875rem;
  color: #666;
  text-align: center;
}

.mobile-menu-button {
  width: 100%;
  padding: 0.75rem;
  margin: 0.5rem 0;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: background 0.2s;
}

.mobile-menu-button:hover {
  background: #5568d3;
}

/* Show mobile menu on mobile devices */
@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: block;
  }

  /* Hide desktop navigation on mobile */
  .header-nav-section {
    display: none !important;
  }

  .header-right {
    display: none !important;
  }
}

/* Show menu when open */
.mobile-menu-overlay {
  display: none;
}

.mobile-menu {
  display: none;
}

.mobile-menu-overlay[style*="display: block"],
.mobile-menu[style*="display: flex"] {
  display: block;
}

.mobile-menu[style*="display: flex"] {
  display: flex;
}

`, "",{"version":3,"sources":["webpack://./src/MobileMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE;IACE,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".mobile-menu-toggle {\n  display: none;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  z-index: 1001;\n  position: relative;\n}\n\n.hamburger {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 24px;\n  height: 20px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.hamburger span {\n  width: 100%;\n  height: 2px;\n  background: white;\n  border-radius: 2px;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.hamburger.open span:nth-child(1) {\n  transform: rotate(45deg) translate(6px, 6px);\n}\n\n.hamburger.open span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.open span:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n}\n\n.mobile-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  display: none;\n}\n\n.mobile-menu {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 280px;\n  height: 100vh;\n  background: white;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  display: none;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.mobile-menu-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #e9ecef;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.mobile-menu-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n}\n\n.mobile-menu-close {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 2rem;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.mobile-menu-links {\n  flex: 1;\n  padding: 1rem 0;\n}\n\n.mobile-menu-links a {\n  display: block;\n  padding: 1rem 1.5rem;\n  color: #333;\n  text-decoration: none;\n  border-bottom: 1px solid #f0f0f0;\n  transition: background 0.2s;\n}\n\n.mobile-menu-links a:hover {\n  background: #f8f9fa;\n}\n\n.mobile-menu-links a.active {\n  background: #e7e9fd;\n  color: #667eea;\n  font-weight: 600;\n  border-left: 3px solid #667eea;\n}\n\n.mobile-menu-footer {\n  padding: 1rem;\n  border-top: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n\n.mobile-user-info {\n  padding: 0.75rem 0;\n  font-size: 0.875rem;\n  color: #666;\n  text-align: center;\n}\n\n.mobile-menu-button {\n  width: 100%;\n  padding: 0.75rem;\n  margin: 0.5rem 0;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.mobile-menu-button:hover {\n  background: #5568d3;\n}\n\n/* Show mobile menu on mobile devices */\n@media (max-width: 768px) {\n  .mobile-menu-toggle {\n    display: block;\n  }\n\n  /* Hide desktop navigation on mobile */\n  .header-nav-section {\n    display: none !important;\n  }\n\n  .header-right {\n    display: none !important;\n  }\n}\n\n/* Show menu when open */\n.mobile-menu-overlay {\n  display: none;\n}\n\n.mobile-menu {\n  display: none;\n}\n\n.mobile-menu-overlay[style*=\"display: block\"],\n.mobile-menu[style*=\"display: flex\"] {\n  display: block;\n}\n\n.mobile-menu[style*=\"display: flex\"] {\n  display: flex;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
